import { pensionApiClient as rawPensionApiClient } from './apis'
import {
	ApiClient,
	mapErrorResponse,
	platformService,
} from '@monthio/react-components'

export interface PensionAuthenticateDto {
	token: string
	pensionSessionId: string
	regionId: string
	clientId: number
	finishedOn: Date | null
	isApplicantEligibleForPensionsInfo: boolean
}

export async function exchangeTokenTransfer(
	exchangeCode: string,
	state: string,
): Promise<string> {
	try {
		return await rawPensionApiClient.get(
			`mitid/pensionsinfo-controlled-transfer?exchangeCode=${exchangeCode}&state=${state}`,
		)
	} catch (error: any) {
		return Promise.reject(mapErrorResponse(error))
	}
}

class PensionApiClient {
	private apiClient = null as unknown as ApiClient

	public initialize() {
		this.apiClient = platformService.createApiClient(
			platformService.getAppUrl('pensionApp'),
			{ appendApi: true },
		)
	}

	public authenticateSession = async (pensionsInfoMinAge?: number) => {
		try {
			const queryParameters =
				pensionsInfoMinAge == undefined
					? ''
					: `?pensionsInfoMinAge=${pensionsInfoMinAge}`
			const response = await this.apiClient
				.useCredentials('include')
				.get<PensionAuthenticateDto>(
					`pension-sessions/authenticate${queryParameters}`,
				)
			return response
		} catch (error: any) {
			return Promise.reject(this.apiClient.mapError(error))
		}
	}

	public getMitIdLoginUrl = async (): Promise<string> => {
		try {
			return await this.apiClient.get(`mitid/login-url`)
		} catch (error: any) {
			return Promise.reject(this.apiClient.mapError(error))
		}
	}
}

export const pensionApiClient = new PensionApiClient()
